module.exports = __webpack_public_path__ + "img/cnu_main0.2b91a638.jpg";